
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import FactFileImageCarousel from '@/src/pages/FactFile/components/FactFileImageCarousel';
import HeadMeta from '@components/HeadMeta';
import Layout from '@components/MyLayout';
import cx from 'classnames';
import SegmentPage from '@components/SegmentPage';
import { FACT_FILE_INDEX } from '@constants/routes';
import GenericPageComponents from '@components/GenericPageComponents';
import FactFileSearchInput from '@components/FactFileSearchInput';
import { trackClickEvent } from '@utils/analytics';
import { useRouter } from 'next/router';
import StyledHeading from '@components/StyledHeading';
import { useGlobalState as GenericPageGlobalState } from '../../globalStates/GenericPageState';
import PageProvider from '../../contexts/page-context';
import Badge from './components/Badge';
import BackToFactFile from './components/BackToFactFile';
import Breadcrumbs from './components/Breadcrumbs';
import Sidebar from './components/Sidebar';
import RelatedEntries from './components/RelatedEntries';
import RandomFactFileButton from '../FactFileIndex/components/FactFileFilterBar/RandomFactFileButton';
import s from './FactFile.module.scss';
const TextRenderer = dynamic(import('@components/MarkDownIt'));
const propTypes = {
    content: PropTypes.array.isRequired,
    factFilesData: PropTypes.array.isRequired
};
const FactFile = ({ content, factFilesData }) => {
    const router = useRouter();
    const [, setIsGenericPage] = GenericPageGlobalState('isGenericPage');
    const analyticsName = 'Fact File';
    const { contentfulId, category, externalId, displayTitle, bodyText, images, sidebarText, relatedEntries, contentSlots, openGraphTitle, openGraphDescription, searchTitle, searchDescription, } = content[0]?.body;
    const containsVideo = contentSlots?.some((slot) => {
        return (slot.contentTypeId === 'video' ||
            (slot.contentTypeId === 'hero' && slot.mainVideo) ||
            slot.text?.includes('https://www.youtube-nocookie.com/embed/') ||
            slot.text?.includes('https://www.youtube.com/embed/'));
    });
    const mainImage = (images && images[0]?.image?.file?.url) ?? '';
    const analyticsParams = {
        content_id: contentfulId,
        content_name: displayTitle
    };
    const selectRandomFactFile = () => {
        const randomIndex = Math.floor(Math.random() * factFilesData.length);
        const randomFactFile = factFilesData[randomIndex];
        const randomFactFileUrl = `${FACT_FILE_INDEX}/${randomFactFile.category}/${randomFactFile.externalId}`;
        trackClickEvent({
            destination_url: randomFactFileUrl,
            label: 'Summon a random fact file'
        });
        router.push(randomFactFileUrl);
    };
    useEffect(() => {
        // bool used to differentiate components when used on both GenericPage or otherwise
        setIsGenericPage(true);
        return () => {
            setIsGenericPage(false);
        };
    }, []);
    return (<Layout location="FactFile">
      <>
        <HeadMeta title={`${searchTitle || displayTitle} | Official Harry Potter Encyclopedia`} omitTitlePrefix description={searchDescription || 'Fact File'} canonicalUrl={`${FACT_FILE_INDEX}/${category}/${externalId}`} ogTitle={openGraphTitle} ogDescription={openGraphDescription} ogImage={`${mainImage}?w=1200&fit=fill&f=top`} twitterImage={`${mainImage}?w=1200&fit=fill&f=top`}/>
        <SegmentPage key={`${category}-${externalId}`} pageName={analyticsName} otherProps={{
            contains_video: containsVideo
        }}/>
        <div className={cx(s.root, category)}>
          <FactFileSearchInput />
          <div className={s.factContainer}>
            <div className={s.factHeader}>
              <Breadcrumbs category={category} analyticsParams={analyticsParams}/>
              <h1>
                <StyledHeading text={displayTitle}/>
              </h1>
              <Badge category={category} analyticsParams={analyticsParams}/>
            </div>
            <div className={s.factLower}>
              <div className={s.entry}>
                <div className={s.carouselContainer}>
                  {images?.length > 0 && <FactFileImageCarousel images={images}/>}
                </div>
                <TextRenderer className={cx(s.bodyText, images?.length > 0 ? '' : s.upperBorder)} text={bodyText?.text} Component={'div'}/>
              </div>
              {sidebarText?.text && (<div className={s.sidebar}>
                  <Sidebar text={sidebarText.text}/>
                </div>)}
            </div>
          </div>
          {contentSlots && (<PageProvider initialPageName={analyticsName}>
              <div className={s.genericPageComponentsContainer}>
                <div className={s.border}>
                  <hr />
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M14.3848 7.13521L9.61473 5.16145L7.89217 0.2268L5.9182 5.16145L0.98383 6.71924L5.9182 8.85798L7.47647 13.6277L9.61473 8.85798L14.3848 7.13521Z" fill="#6B63B5"/>
                  </svg>
                  <hr />
                </div>
                <GenericPageComponents contentSlots={contentSlots} pageData={content}/>
              </div>
            </PageProvider>)}
          <div className={s.randomFactFileContainer}>
            <RandomFactFileButton selectRandomFactFile={selectRandomFactFile} isMobile/>
          </div>

          {relatedEntries && relatedEntries.length > 0 && (<>
              <RelatedEntries content={relatedEntries}/>
            </>)}
          <BackToFactFile category={category} analyticsParams={analyticsParams}/>
        </div>
      </>
    </Layout>);
};
FactFile.propTypes = propTypes;
export default FactFile;

    async function __Next_Translate__getStaticProps__195ca0c99d6__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0c99d6__ as getStaticProps }
  